import React from 'react';
import { SegmentedControl, Text, Stack } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface RatingInputProps {
  value: number | null;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const data = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const RatingInput: React.FC<RatingInputProps> = ({ value, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <Stack gap={4}>
      <SegmentedControl
        data={data}
        value={value != null ? String(value) : ''}
        onChange={(v) => onChange(Number(v))}
        color="teal"
        fullWidth
        disabled={disabled}
      />
      {value != null && (
        <Text size="sm" c="dimmed" ta="center">
          {t(`review360.ratingLabels.${value}`)}
        </Text>
      )}
    </Stack>
  );
};
